import React, { useEffect, useRef, useState } from 'react';

import Modal from '../../modules/Modal';
import styles from '../Timeline.module.scss';
import { ContainedButton, OutlinedButton } from '../../modules/Buttons';
import { findSearchValue } from '../../../helpers/getSearchValue';
import { NOTIFICATION } from '../../../enums/ENUMS';
import { createEmptyRow } from '../../../api';
import { useSnackbar } from 'material-ui-snackbar-provider';
import { TOPIC } from '../../../enums';
import { useHotkeys } from 'react-hotkeys-hook';

type TCreateRowModal = {
  open: boolean;
  switchModal: () => void;
  createdNewRowCallBack: (data: TOPIC) => void;
  position?: 'top' | 'bottom';
};

const CreateRowModal: React.FC<TCreateRowModal> = ({ open, switchModal, createdNewRowCallBack, position }) => {
  const [title, setTitle] = useState('');
  const [loading, setLoading] = useState(false);

  const notification = useSnackbar();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (!open) return;

    const rafId = requestAnimationFrame(() => {
      inputRef.current?.focus();
    });

    return () => cancelAnimationFrame(rafId);
  }, [open]);

  const closeModal = () => {
    switchModal();
    setLoading(false);
    setTitle('');
  };

  const onSubmit = async (e?: React.FormEvent<HTMLFormElement>) => {
    e?.preventDefault();

    const feedId = findSearchValue('feedId') as string;

    try {
      setLoading(true);
      const res = await createEmptyRow(title, feedId, position);
      if (res.data.id) createdNewRowCallBack(res.data);
      closeModal();
    } catch (err) {
      // @ts-ignore — відсутність типів у бібліотечних помилках
      if (err?.response?.data?.message) {
        // @ts-ignore
        notification.showMessage(err.response.data.message);
      } else {
        notification.showMessage(NOTIFICATION.SOMETHING_WENT_WRONG);
      }
    } finally {
      setLoading(false);
    }
  };

  const onTitleChange = (e: React.ChangeEvent<HTMLInputElement>) => setTitle(e.target.value);

  return (
    <Modal open={open} onClose={closeModal} loading={loading}>
      <form className={styles.modal} onSubmit={onSubmit}>
        <div className={styles.modalTitle}>Please create a name for new row</div>

        <div className={styles.rowInputContainer}>
          <input ref={inputRef} autoFocus placeholder="Enter row name" required value={title} onChange={onTitleChange} />
        </div>

        <div className={styles.actionBtns}>
          <ContainedButton disabled={!title.length} type="submit">
            Create new row
          </ContainedButton>
          <OutlinedButton onClick={closeModal}>Cancel</OutlinedButton>
        </div>
      </form>
    </Modal>
  );
};

export default CreateRowModal;
